import {useDispatch} from "react-redux";
import {useEffect} from "react";
import axios from "axios";
import {changeIcons} from "../../_redux/slices/navSlice";
import {useTranslation} from "react-i18next";

export default function NotFoundPage_404() {
    const {t: trans} = useTranslation(["messages"]);

    const dispatch = useDispatch();
    useEffect(async () => {

        dispatch(
            changeIcons({iconsBlack: true})
        )

        return () => {
            dispatch(
                changeIcons({iconsBlack: false})
            )
        }
    }, []);
    return (
        <div className={"container error-page my-32"}>
            <div className="error-text">

                <div className="error-heading">
                    {trans("messages:page_not_found")}
                </div>
                <h1 className={"error-code"}>
                    404
                </h1>
                <p className="error-message">
                    {trans("messages:page_not_found_message")}    
                </p>

            </div>

            <div className={'error-image'}>
                <img src="/assets/svg_background/error.svg" alt=""/>
            </div>
        </div>
    );
}